import { render, staticRenderFns } from "./seriesPage.vue?vue&type=template&id=ce8075d2&scoped=true&"
import script from "./seriesPage.vue?vue&type=script&lang=js&"
export * from "./seriesPage.vue?vue&type=script&lang=js&"
import style0 from "./seriesPage.vue?vue&type=style&index=0&id=ce8075d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8075d2",
  null
  
)

export default component.exports